// extracted by mini-css-extract-plugin
module.exports = {"row":"projectsListItemSkeleton_row__37zqO","title":"projectsListItemSkeleton_title__3o7AT"};